/*
 * Merchant: "if a user uses a go back hotkey it takes them back to the
 * manifest" — browser Back (the button, a trackpad/mouse gesture, or the
 * OS/browser back shortcut, e.g. Alt+Left on Windows/Linux or Cmd+[ on Mac)
 * should always land on the Manifest page, every time it's pressed.
 *
 * The app's own router (assets/sat-app.js's syncHash) uses
 * history.replaceState for every in-app page change, never pushState — so
 * normally there is no back-able history entry at all, and pressing Back
 * just leaves the site outright for whatever page was open before it.
 * `armTrap` pushes one sentinel history entry so the next Back stays on
 * this page (fires `popstate`) instead of navigating away; the popstate
 * handler forces Manifest and immediately re-arms the trap, so this repeats
 * for every subsequent Back press, not just the first.
 *
 * Merchant (follow-up): "clicking the home button on the header takes you
 * to the manifest not the main page" — and the same thing happened on
 * every other in-app nav link (header nav, footer links), not just Home.
 * Root cause: every one of those links is a real `<a href="#">` with an
 * onClick handler that never calls preventDefault (the handlers, e.g.
 * goHome in assets/sat-app.js, don't even receive the click event). So a
 * click does two things at once: the onClick handler runs the real in-app
 * navigation (setState({page:'home'})), AND the browser separately follows
 * the href, which is a real same-document history traversal to a new
 * fragment — and that traversal fires its own `popstate`, same event this
 * file already listens for. The popstate handler couldn't tell that apart
 * from a genuine Back press, so it unconditionally overwrote whatever page
 * the click had just navigated to with Manifest.
 *
 * Fixed by distinguishing the two cases instead of reacting to every
 * popstate: a real Back press moves the history pointer within the
 * existing stack, so history.length is unchanged when it fires. A nav-link
 * click (or anything else that creates a brand new entry without calling
 * preventDefault) appends to the stack, so history.length has grown. Only
 * the unchanged case re-arms into Manifest; the grown case is left alone
 * (just re-synced so future comparisons stay correct) so the click's own
 * in-app navigation stands.
 */
(function () {
  'use strict';
  if (!window.SATComponent) { return; }

  var armedLength = 0;

  function armTrap() {
    history.pushState({ satBackTrap: true }, '', location.hash || location.pathname);
    armedLength = history.length;
  }

  window.addEventListener('popstate', function () {
    var app = window.SATApp;
    if (!app) { return; }
    if (history.length !== armedLength) {
      // Not a real Back — a new entry was appended (e.g. an in-app <a href="#">
      // nav link completing its default navigation). Leave whatever page that
      // click just navigated to alone; just re-sync so the next real Back is
      // still measured correctly.
      armTrap();
      return;
    }
    if (location.hash !== '#manifest') {
      history.replaceState(null, '', '#manifest');
    }
    app.setState({ page: 'manifest' });
    window.scrollTo(0, 0);
    armTrap();
  });

  armTrap();
})();
